const LAST_SHOP_KEY = "baback:last-shop-id";

/** The shop opened last on this browser, to land there next time. */
export function rememberLastShop(shopId: string) {
  try {
    localStorage.setItem(LAST_SHOP_KEY, shopId);
  } catch {
    // Private mode or storage full: landing falls back to the first shop.
  }
}

export function forgetLastShop() {
  try {
    localStorage.removeItem(LAST_SHOP_KEY);
  } catch {
    // Nothing remembered then.
  }
}

export function readLastShop(): string | null {
  try {
    return localStorage.getItem(LAST_SHOP_KEY);
  } catch {
    return null;
  }
}

/**
 * Where `/` lands: the first preferred shop still reachable (the super admins'
 * default shop, then the last one opened), else the first reachable one. A
 * super admin reaches every shop without being a member (BAB-3035), so
 * `reachable` is then every shop, live ones first. Undefined when there is
 * none.
 */
export function pickLandingShopId(
  reachable: { id: string }[],
  preferredShopIds: (string | null | undefined)[],
): string | undefined {
  const preferred = preferredShopIds.find(
    (shopId) => shopId && reachable.some((shop) => shop.id === shopId),
  );
  return preferred ?? reachable[0]?.id;
}
